import { lazy } from 'react';

const Orders = lazy(() => import('./Orders'));

export default Orders;
